import template from './ko-field-input-currency.html';

class CurrencyInputComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.readonly = ko.observable(false);
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.multiline = ko.observable(false);
		this.rows = ko.observable();
		this.auto_select = ko.observable(params.ui_fields?.auto_select ?? params.auto_select ?? false);
		this.help_text = ko.observable(params.help_text);
		this.step = ko_helper.safe_observable(params.step);

		if (params.ui_fields)
		{
			this.multiline(params.ui_fields.multiline);
			this.rows(params.ui_fields.rows);
			this.readonly(params.ui_fields.readonly);
		}
		else
		{
			if (params.rows)
				this.rows(params.rows);
			if (params.multiline)
				this.multiline(params.multiline);
			if (params.readonly)
				this.readonly(params.readonly);
		}
	}
}


export default {
	name: 'ko-field-input-currency',
	viewModel: CurrencyInputComponentVM,
	module_type: 'ko',
	template: template
}
